export const quote_url: string = "quote";
export const email_quote_url: string = "email_quote";